import React from 'react';
import { Card, CardContent } from '../../ui/card';
import { BarChart2, FileText, Trophy, Award, BookOpen, ChevronRight } from 'lucide-react';

export const ReportsHubContent = ({ setActiveSection }) => {
  const sections = [
    { id: 'statistics', title: 'İstatistikler', description: 'Genel platform istatistikleri ve analizler', icon: <BarChart2 className="w-6 h-6" />, stats: 'Genel Bakış', color: 'blue' },
    { id: 'reports', title: 'Öğrenci Raporları', description: 'Öğrenci ilerleme ve performans raporları', icon: <FileText className="w-6 h-6" />, stats: 'Detaylı Raporlar', color: 'purple' },
    { id: 'leaderboard', title: 'Liderlik Tablosu', description: 'En başarılı öğrenciler ve sıralamalar', icon: <Trophy className="w-6 h-6" />, stats: 'Sıralama', color: 'amber' },
    { id: 'scoring', title: 'Puanlama', description: 'Puan sistemi ayarları ve yönetimi', icon: <Award className="w-6 h-6" />, stats: 'Puan Yönetimi', color: 'green' },
    { id: 'documents', title: 'Dokümanlar', description: 'Kullanım kılavuzu ve eğitim içerik özeti', icon: <BookOpen className="w-6 h-6" />, stats: 'PDF & Kılavuz', color: 'cyan' },
    { id: 'placement-results', title: 'Seviye Sınavı Sonuçları', description: 'Öğrenci seviye tespit sınavı sonuçları', icon: <FileText className="w-6 h-6" />, stats: 'Sınav Sonuçları', color: 'pink' }
  ];

  const colorClasses = {
    blue: 'bg-blue-100 text-blue-600',
    purple: 'bg-purple-100 text-purple-600',
    amber: 'bg-amber-100 text-amber-600',
    green: 'bg-green-100 text-green-600',
    cyan: 'bg-cyan-100 text-cyan-600',
    pink: 'bg-pink-100 text-pink-600'
  };

  return (
    <div className="space-y-6">
      <div className="flex items-center gap-3 mb-5 pb-3 border-b border-gray-200">
        <div className="p-2 bg-blue-600 rounded-lg text-white">
          <BarChart2 className="w-5 h-5" />
        </div>
        <div>
          <h2 className="text-lg font-semibold text-gray-800">Raporlar</h2>
          <p className="text-sm text-gray-500">İstatistikler, raporlar ve analizler</p>
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {sections.map(section => (
          <Card 
            key={section.id}
            className="border border-gray-200 hover:border-blue-300 hover:shadow-md transition-all cursor-pointer group bg-white"
            onClick={() => setActiveSection(section.id)}
          >
            <CardContent className="p-5">
              <div className="flex items-start gap-4">
                <div className={`p-3 rounded-lg ${colorClasses[section.color]}`}>
                  {section.icon}
                </div>
                <div className="flex-1 min-w-0">
                  <h3 className="font-semibold text-gray-800 group-hover:text-blue-600 transition-colors">{section.title}</h3>
                  <p className="text-sm text-gray-500 mt-1">{section.description}</p>
                  <span className="inline-block mt-2 text-xs text-gray-400 bg-gray-100 px-2 py-1 rounded">{section.stats}</span>
                </div>
                <ChevronRight className="w-5 h-5 text-gray-300 group-hover:text-blue-500 group-hover:translate-x-1 transition-all flex-shrink-0" />
              </div>
            </CardContent>
          </Card>
        ))}
      </div>
    </div>
  );
};

export default ReportsHubContent;
